import AppRoutes from './app/routes';
import './styles/global.css';
import './styles/layout.css';
import './styles/home.css';
import './styles/pages.css';
import './styles/services.css';
import './styles/admin.css';
import './styles/adminEmails.css';

function App() {
  return <AppRoutes />;
}

export default App;
